import { useEffect, useState } from 'react';
import { accesDe, voitCommeCeo } from '@/shared/auth/droits';
import { Outlet, useLocation } from 'react-router-dom';
import { useUtilisateur } from '@/shared/auth/contexte';
import { FiletErreur } from '@/shared/ui';
import { PaletteRecherche } from '../recherche/PaletteRecherche';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/** La coque : navigation flottante, en-tête, contenu. Même structure que Retraitia. */
export function AppShell() {
  const utilisateur = useUtilisateur();
  const { pathname } = useLocation();
  const [rechercheOuverte, setRechercheOuverte] = useState(false);
  const [menuOuvert, setMenuOuvert] = useState(false);

  useEffect(() => {
    function raccourci(evenement: KeyboardEvent) {
      if ((evenement.ctrlKey || evenement.metaKey) && evenement.key.toLowerCase() === 'k') {
        evenement.preventDefault();
        setRechercheOuverte((ouverte) => !ouverte);
      }
    }
    window.addEventListener('keydown', raccourci);
    return () => {
      window.removeEventListener('keydown', raccourci);
    };
  }, []);

  return (
    <div className="flex min-h-full">
      <a
        href="#contenu"
        className="sr-only rounded-md bg-primary px-4 py-2 text-white focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50"
      >
        Aller au contenu
      </a>

      <div className="hidden shrink-0 py-3 pl-3 lg:block">
        <div className="sticky top-3 h-[calc(100vh-24px)]">
          <Sidebar utilisateur={utilisateur} />
        </div>
      </div>

      {menuOuvert ? (
        <div
          className="fixed inset-0 z-40 bg-nav/40 lg:hidden"
          onClick={() => {
            setMenuOuvert(false);
          }}
        >
          <div
            className="h-full w-64 p-3"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Sidebar
              utilisateur={utilisateur}
              onNaviguer={() => {
                setMenuOuvert(false);
              }}
            />
          </div>
        </div>
      ) : null}

      <div className="flex min-w-0 flex-1 flex-col">
        <Header
          utilisateur={utilisateur}
          onOuvrirRecherche={() => {
            setRechercheOuverte(true);
          }}
          onOuvrirMenu={() => {
            setMenuOuvert(true);
          }}
        />
        <main id="contenu" className="flex flex-1 flex-col gap-5 px-4 pt-1 pb-10 lg:px-7">
          {/* Une clé par adresse : changer d'écran efface l'erreur du précédent. */}
          <FiletErreur key={pathname}>
            <Outlet />
          </FiletErreur>
        </main>
      </div>

      {rechercheOuverte ? (
        <PaletteRecherche
          role={accesDe(utilisateur)}
          ceo={voitCommeCeo(utilisateur)}
          onFermer={() => {
            setRechercheOuverte(false);
          }}
        />
      ) : null}
    </div>
  );
}
